import { SizeStylePluginConfig } from "@paperbits/styles/plugins";

export const sizeStylesInitial: SizeStylePluginConfig = {
    height: "500px",
    width: "100%",
};